import React from "react";

type Props = {
  title?: string;
  compact?: boolean;
  center?: boolean;
  visible: boolean;
  onClose: () => void;
  style?: string;
  stylecontent?: string;
};

const Modal: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  compact,
  center,
  visible,
  onClose,
  style,
  stylecontent,
}) => {
  const closeModal = (e: any) => {
    if (e.target.classList[0] === "modal") {
      onClose();
    }
  };

  return (
    <div className="modal-section">
      <input
        className="modal-btn"
        type="checkbox"
        id="modal-btn"
        name="modal-btn"
        checked={visible}
        onChange={() => {}}
      />
      <div onClick={closeModal} className="modal">
        <div
          className={`modal-wrap ${style ? style : "p-54"}  ${
            compact ? "compact" : ""
          }`}
        >
          {title && <h2 className="text-lg font-bold">{title}</h2>}
          <div
            className={`modal-content ${stylecontent ? stylecontent : ""} ${
              compact ? "compact" : ""
            } ${center ? "center" : ""} `}
          >
            <div onClick={() => onClose()} className="model-icon-wrap">
              <span className="modal-icon">&nbsp;</span>
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
